import React from 'react';
import { ReferenceArrayInput } from 'react-admin';
import { Grid } from '@material-ui/core/';
import GridInput from '../../../core/components/inputs/GridInput';

const validateFunds = value => {
  if (Array.isArray(value) && value.length < 1) {
    return 'At least one Fund must be selected';
  }
  return undefined;
};

const OrphanFundsGridInput = props => {
  const { choices } = props;

  //Preselecting the orphan funds:
  //First lets select only funds which does not have Fund Family
  //That is necessary because we can add into FF only FUND which is orphan.
  var preselectedChoices = [];
  if (choices.length > 0) {
    choices.forEach(choice => {
      if (choice.fundFamilyId === null) {
        preselectedChoices.push(choice);
      }
    });
  }

  return preselectedChoices.length > 0 ? (
    <GridInput
      {...props}
      choices={preselectedChoices}
      optionValueLabel={'Fund ID'}
      optionTextLabel={'Fund Name'}
      additionalColumns={[
        { label: 'Status', name: 'status', isStatusColumn: true }
      ]}
    />
  ) : (
    <span>There are no Orphan Funds to be displayed</span>
  );
};

const AddExistingOrphanFundSummary = () => {
  return (
    <div>
      <Grid container spacing={1}>
        <Grid item sm={12}>
          <ReferenceArrayInput
            label="To add Fund to this Fund Family, select one or multiple items from the list of the Funds below."
            optionText="Fund Name"
            optionValue="Fund ID"
            resource="funds"
            reference="funds"
            source="funds"
            validate={[validateFunds]}
            perPage={-1}
            sort={{ field: 'name', order: 'ASC' }}
          >
            <OrphanFundsGridInput />
          </ReferenceArrayInput>
        </Grid>
      </Grid>
    </div>
  );
};

export default AddExistingOrphanFundSummary;
